/**
 * Created by lihanying on 2017/7/6.
 */

export const GETMARKETTYPE = 'GETMARKETTYPE'
export const GETMARKETLIST = 'GETMARKETLIST'
export const GETPERIOD = 'GETPERIOD'
export const GETMARKETRECORD = 'GETMARKETRECORD'
export const GETMARKETSCALELIST = 'GETMARKETSCALELIST'
export const GETMARKETSUM = 'GETMARKETSUM'


// WEBPACK FOOTER //
// ./src/containers/ClubMarket/constants.js